









import Vue from 'vue'

export default Vue.extend({
  name: 'SearchButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass (): string {
      return this.loading ? 'fa-spin fa-spinner' : 'fa-search'
    }
  }
})
